// Which pages Enhance can read (AC-OCR-5): found from the page's text and images as the engine reports them.
import type { ImageInfo, SpanInfo } from '../engine/worker/protocol.ts';

/** scan: the page is a picture (Enhance can read it); layer: a picture with its own invisible text; none: neither */
export type PageKind = 'scan' | 'layer' | 'none';

/** A page is a picture when one image covers at least this share of it. */
const SCAN_COVER = 0.5;

const area = (q: [number, number][]) => Math.abs(q.reduce((a, p, k) => a + p[0] * q[(k + 1) % q.length][1] - q[(k + 1) % q.length][0] * p[1], 0)) / 2;

/** The page's largest image, if it covers enough of the page (pageArea, pt²) to make it a scan. */
export function scanImage(images: ImageInfo[], pageArea: number): ImageInfo | undefined {
  const big = [...images].sort((a, b) => area(b.quad) - area(a.quad))[0];
  return big && area(big.quad) >= SCAN_COVER * pageArea ? big : undefined;
}

/** A picture with no visible text is a scan; with invisible text, it has its own layer. Recognised words do not count. */
export function pageKind(spans: SpanInfo[], images: ImageInfo[], pageArea: number): PageKind {
  const own = spans.filter((s) => !s.ocr);
  if (own.some((s) => !s.invisible) || !scanImage(images, pageArea)) return 'none';
  return own.some((s) => s.invisible) ? 'layer' : 'scan';
}
